import superagent from 'superagent';

const api = {
    // get manifest as flat array, or pass "/metrics" to return hierarchical array
    getManifest: async function(manifest = '/metrics'){
        var url = '/wp-json/wp/v2/manifests'+manifest;
        async function fetchManifest(){
            return superagent.get(url);
        }
        return await fetchManifest();
    },
    // returns state data based on passed args
    getStateData: async function(args){
        async function fetchData(url){
            return superagent.get(url);
        }
        var url = new URL(window.location.origin + '/wp-json/wp/v2/states');
        Object
            .keys(args)
            .forEach(key => url.searchParams.append(key, args[key]));
        return await fetchData(url);
    }
};

export default api;
